export default __webpack_public_path__ + "static/media/Queen-Annes-Lace_L2.5e31c07c.png";